import { TERTIARY_ORGANIZATION_COLOR } from '../../theme/OrganizationTheme';

export const WaveBackground = () => (
    <svg viewBox="32.666 89.444 296.035 59.5065" xmlns="http://www.w3.org/2000/svg">
        <path
            className={TERTIARY_ORGANIZATION_COLOR}
            d="M 32.666 89.444 L 328.854 89.444 L 328.854 144.108 C 248.027 174.14 113.956 50.782 32.666 146.493 L 32.666 90.158 Z"
        />
    </svg>
);
